<template>
    <div v-if="$store.state.is_manager">
        <div class="select-container clearfix" style="margin-top: 6%;margin-left: 33%;float: center;">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="文档标题">
                    <el-col :span="6">
                        <el-input v-model="form.title"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="父目录">
                    <el-cascader v-model="selectedItemList" change-on-select :options="form.options" clearable></el-cascader>
                    若需创建在根目录下则无需选择
                </el-form-item>
                <el-form-item label="文档类型">
                    <el-radio-group v-model="form.type">
                        <el-radio label="目录"></el-radio>
                        <el-radio label="文本"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="语言">
                  <el-radio-group v-model="form.language" >
                    <el-radio label="zh">中文</el-radio>
                    <el-radio label="en">英文</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">立即创建</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>


<script>
    import axios from "axios";
    import {mapState} from "vuex";

    export default {
        name: "addItem",
        mounted: function () {
            var vm = this;
            if (!(vm.$store.state.is_manager)) {
                this.$notify({
                    title: '没有权限',
                    message: '你没有操作当前菜单的权限',
                    type: 'error'
                });
                return;
            }
            if (vm.token == "") {
                var token = vm.getCookie("access-token");
                if (token != null) {
                    vm.$store.commit('UPDATETOKEN', token);
                    vm.token = token;
                }
            }
            this.$nextTick(() => {
                // 请求新增的目录
                axios.get(vm.selectItemList, {
                    withCredentials: true
                }).then((response) => {
                    if (response.data && response.data.status === 401) {
                        window.location = vm.loginRediret;
                        return;
                    }
                    let itemList = response.data.data;
                    if (!itemList || itemList.length === 0) {
                        return;
                    }
                    vm.$set(vm.form, 'options', itemList);
                }).catch(function (error) {
                    vm.requesterrorinfo(error)
                })
            });
        },
        computed: mapState({
            addItem: function (state) {
                return state.addItem;
            },
            selectItemList: function (state) {
                return state.selectItemList;
            },

        }),
        data() {
            return {
                form: {
                    title: '',
                    type: '目录',
                    options: new Array(),
                    language: 'zh'
                },
                token: '',
                selectedItemList:[],
            }
        },
        methods: {
            getCookie(name) {
                var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
                if (arr = document.cookie.match(reg))
                    return unescape(arr[2]);
                else
                    return null;
            },
            requesterrorinfo(error) {
                var vm = this;
                if (error.response) {
                    var code = error.response.status;
                    if (code == 401) {
                        document.cookie = "currentURL=addItem";
                        window.location = vm.loginRediret;
                    } else {
                        if (code == 404) {
                            vm.$notify({
                                title: '提示',
                                message: '404:Not found!',
                                type: 'error'
                            });
                        } else {
                            vm.$notify({
                                title: '提示',
                                message: '501:服务端未响应!',
                                type: 'error'
                            });
                        }
                    }
                } else {
                    vm.$notify({
                        title: '提示',
                        message: '502:服务端未响应!',
                        type: 'error'
                    });
                }
            },
            // 添加目录
            onSubmit() {
                var vm = this;
                let fatherDirId = '0';
                let index = '';
                let item = null;
                if (vm.form.title == null || vm.form.title.trim() == '') {
                    this.$message.error('文档标题不得为空，请输入后重新提交！');
                    return;
                }
                // 如果父目录为空，则在根目录下创建文档
                var length = this.selectedItemList.length;
                if (length == 0) {
                    var lt = vm.form.options.length;
                    if (lt === 0) {
                        index = '1';
                    } else {
                        index = (parseInt(vm.form.options[lt - 1].value) + 1) + '';
                    }
                    if (vm.form.type === '文本') {
                        this.$message.error('根目录只能创建目录项，无法创建文本！');
                        return;
                    } else {
                        item = {value: index, label: vm.form.title, fatherIndex: '0', children: [], isDir: 1, language: vm.form.language}
                    }
                    vm.form.options.push(item);
                } else {
                    // 如果父目录不为空，则在指定的父目录下创建文档
                    let values = this.selectedItemList;
                    fatherDirId = this.selectedItemList[values.length - 1];
                    var strings = fatherDirId.split('-');
                    if (strings.length == 1) {
                        // 一级子目录
                        var children = null;
                        var options = vm.form.options;
                        for (var i = 0; i < options.length; i++) {
                            if (options[i].value == fatherDirId) {
                                children = options[i].children;
                              if (children == null) {
                                this.$message.error('文本下无法创建！');
                                return;
                              }
                                var childrenLength = children.length;
                                if (childrenLength == 0) {
                                    index = fatherDirId + '-' + 1;
                                } else {
                                    var lastIndex = parseInt(children[childrenLength - 1].value.split('-')[1]) + 1;
                                    index = fatherDirId + '-' + lastIndex;
                                }
                                if (vm.form.type == '文本') {
                                    item = {value: index, label: vm.form.title, fatherIndex: fatherDirId, isDir: 0, language: vm.form.language}
                                } else {
                                    item = {
                                        value: index,
                                        label: vm.form.title,
                                        fatherIndex: fatherDirId,
                                        children: [],
                                        isDir: 1,
                                        language: vm.form.language
                                    }
                                }
                                options[i].children.push(item);
                            }
                        }
                        vm.form.options = options;
                    } else if (strings.length == 2) {
                        // 二级子目录
                        var children = null;
                        var options = vm.form.options;
                        for (var i = 0; i < options.length; i++) {
                            if (options[i].children != null) {
                                for (var j = 0; j < options[i].children.length; j++) {
                                    if (options[i].children[j].value == fatherDirId) {
                                        children = options[i].children[j].children;
                                        if (children == null) {
                                          this.$message.error('文本下无法创建！');
                                          return;
                                        }
                                        var childrenLength = children.length;
                                        if (childrenLength == 0) {
                                            index = fatherDirId + '-' + 1;
                                        } else {
                                            var lastIndex = parseInt(children[childrenLength - 1].value.split('-')[2]) + 1;
                                            index = fatherDirId + '-' + lastIndex;
                                        }
                                        if (vm.form.type == '文本') {
                                            item = {
                                                value: index,
                                                label: vm.form.title,
                                                fatherIndex: fatherDirId,
                                                isDir: 0,
                                                language: vm.form.language
                                            }
                                        } else {
                                            item = {
                                                value: index,
                                                label: vm.form.title,
                                                fatherIndex: fatherDirId,
                                                children: [],
                                                isDir: 1,
                                                language: vm.form.language
                                            }
                                        }
                                        options[i].children[j].children.push(item);
                                    }
                                }
                            }
                        }
                        vm.form.options = options;
                    } else if (strings.length == 3) {
                        // 三级子目录
                        var children = null;
                        var options = vm.form.options;
                        for (var i = 0; i < options.length; i++) {
                            if (options[i].children != null) {
                                for (var j = 0; j < options[i].children.length; j++) {
                                    if (options[i].children[j].children != null) {
                                        for (var k = 0; k < options[i].children[j].children.length; k++) {
                                            if (options[i].children[j].children[k].value == fatherDirId) {
                                                children = options[i].children[j].children[k].children;
                                                if (children == null) {
                                                  this.$message.error('文本下无法创建！');
                                                  return;
                                                }
                                                var childrenLength = children.length;
                                                if (childrenLength == 0) {
                                                    index = fatherDirId + '-' + 1;
                                                } else {
                                                    var lastIndex = parseInt(children[childrenLength - 1].value.split('-')[3]) + 1;
                                                    index = fatherDirId + '-' + lastIndex;
                                                }
                                                if (vm.form.type == '文本') {
                                                    item = {
                                                        value: index,
                                                        label: vm.form.title,
                                                        fatherIndex: fatherDirId,
                                                        isDir: 0,
                                                        language: vm.form.language
                                                    }
                                                } else {
                                                    item = {
                                                        value: index,
                                                        label: vm.form.title,
                                                        fatherIndex: fatherDirId,
                                                        children: [],
                                                        isDir: 1,
                                                        language: vm.form.language
                                                    }
                                                }
                                                options[i].children[j].children[k].children.push(item);
                                            }
                                        }
                                    }
                                }
                            }

                        }
                        vm.form.options = options;
                    }
                }
                if (item.isDir == 1) {
                    // 请求后端
                    axios.post(vm.addItem, item, {
                        withCredentials: true
                    }).then((response) => {
                        vm.$notify({
                            title: '提示',
                            message: '添加目录成功！',
                            type: 'success'
                        });
                        this.selectedItemList = [];
                        vm.form.title = '';
                        vm.form.type = '目录';
                    }).catch(function (error) {
                        vm.requesterrorinfo(error)
                    });
                } else {
                    vm.$router.push({path: '/editorItem', query: {index: index, title: vm.form.title, item: item}});
                }
            },
        },
    }
</script>

<style scoped>
    .el-row {
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// addItem.vue?6559da56